/**
 * CryptidZoo - Main Game Class
 */

import { Engine } from "@engine/index";
import { GameplayScene } from "./scenes/GameplayScene";

export class Game {
    private _engine: Engine;
    private _canvas: HTMLCanvasElement;

    public get canvas(): HTMLCanvasElement {
        return this._canvas;
    }

    constructor(canvas: HTMLCanvasElement) {
        this._canvas = canvas;
        this._engine = new Engine(canvas, {
            antialias: true,
            powerPreference: "high-performance",
        });

        // Setup loading progress callback
        this._engine.onLoadingProgress((progress, message) => {
            this._updateLoadingUI(progress, message);
        });
    }

    /**
     * Initialize and start the game
     */
    public async start(): Promise<void> {
        try {
            this._updateLoadingUI(20, "Creating scenes...");

            // Register scenes
            const gameplayScene = new GameplayScene(this._engine);
            this._engine.sceneManager.registerScene("gameplay", gameplayScene);

            this._updateLoadingUI(50, "Loading gameplay...");

            // Start with gameplay scene
            await this._engine.sceneManager.switchTo("gameplay");

            this._updateLoadingUI(90, "Starting engine...");

            // Start the render loop
            this._engine.start();

            // Hide loading screen
            this._hideLoadingScreen();

        } catch (error) {
            console.error("Failed to start game:", error);
            this._showError("Failed to start game. Please refresh the page.");
        }
    }

    /**
     * Dispose game and cleanup
     */
    public dispose(): void {
        this._engine.dispose();
    }

    /**
     * Update loading UI
     */
    private _updateLoadingUI(progress: number, message: string): void {
        const loadingBar = document.getElementById("loadingBar");
        const loadingText = document.getElementById("loadingText");

        if (loadingBar) {
            loadingBar.style.width = `${progress}%`;
        }
        if (loadingText) {
            loadingText.textContent = message;
        }
    }

    /**
     * Hide loading screen
     */
    private _hideLoadingScreen(): void {
        const loadingScreen = document.getElementById("loadingScreen");
        if (loadingScreen) {
            loadingScreen.classList.add("hidden");
            setTimeout(() => {
                loadingScreen.style.display = "none";
            }, 500);
        }
    }

    /**
     * Show error message
     */
    private _showError(message: string): void {
        const loadingText = document.getElementById("loadingText");
        if (loadingText) {
            loadingText.textContent = message;
            loadingText.style.color = "#e94560";
        }
    }
}
